<template>
    <a
        :class="classes"
        :href="href"
        :target="target"
        :title="parameters.tooltip.value"
        v-html="parameters.text.value"
    ></a>
</template>

<script>
    import Widget from './Widget.vue';

    export default {
        extends: Widget,
        props: {
            parameter: String
        },

        data() {
            return {
                classes: '',
                href: '',
                target: '',
            }
        },

        created() {
            this.registerParameterListener(this.parameter);

            if (this.parameters['new-tab'].value === 'on') {
                this.target = '_blank';
            }

            this.setHref();
        },

        methods: {
            render() {
                this.setHref();
            },

            setHref() {
                let href = this.parameters.url.value;

                if (this.parameters[this.parameter]) {
                    href += '?' + this.parameter + '=' + this.parameters[this.parameter].value;
                }

                this.href = href;
            }
        }
    }
</script>
